import React, { useState } from "react";
import { useDepartments } from "Hooks/AdminHooks/Organization/useDepartments";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Button, Modal, Table } from "antd";
import { toast } from "react-toastify";
import colors from "assets/theme/base/colors";

const Departments = () => {
  const {
    loading,
    departments,
    columns,
    fetchDeaprtments,
    createDepartment,
    updateDepartment,
    editingDepartment,
    setEditingDepartment,
    showForm,
    setShowForm,
    formData,
    setFormData,
  } = useDepartments();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const paylaod = {
      id: editingDepartment ? editingDepartment.id : undefined,
      name: formData.name,
      description: formData.description,
    };
    try {
      if (editingDepartment) {
        await updateDepartment(paylaod);
        toast.success("Department updated successfully");
      } else {
        await createDepartment(paylaod);
        toast.success("Department created successfully");
      }

      fetchDeaprtments();
      setFormData({
        name: "",
        description: "",
      });
      setEditingDepartment(null);
      setShowForm(false);
    } catch (eror) {
      console.error("error in submit detaprtment", eror);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ padding: "24px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <h2 style={{ color: colors.dark.main }}>Departments</h2>
          <Button
  style={{
    backgroundColor: colors.primary.main,
    color: colors.white.main,
    borderColor: colors.primary.main,
  }}
  onClick={() => setShowForm(true)}
>
  + Add Department
</Button>
        </div>
        <Table className="custom-table" columns={columns} dataSource={departments} loading={loading} rowKey="id" />
      </div>

      <Modal
       title={
    <span style={{ color: colors.primary.main }}>
      {editingDepartment ? "Editing Department" : "Create New Department"}
    </span>
  }
        open={showForm}
        onCancel={() => setShowForm(false)}
        footer={null}
      >
        <form onSubmit={handleSubmit}>
          <div>
            <div>
              <label className="form-label small mb-1">Name</label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Please enter Department name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    name: e.target.value,
                  })
                }
              />
            </div>

            <div>
              <label className="form-label small mb-1">Description</label>
              <textarea
                className="form-control form-control-sm"
                placeholder="Please enter Department description"
                rows="3"
                value={formData.description}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    description: e.target.value,
                  })
                }
              />
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-end gap-2 mt-3">
             <Button
  style={{
    backgroundColor: colors.light.main,
    color: colors.dark.main,
    borderColor: colors.secondary.main,
  }}
  size="small"
  onClick={() => setShowForm(false)}
>
  Cancel
</Button>
            <Button
  style={{
    backgroundColor: colors.primary.main,
    color: colors.white.main,
    borderColor: colors.primary.main,
  }}
  size="small"
  className="btn-primary"
  htmlType="submit"
>
  Save
</Button>
            </div>
          </div>
        </form>
      </Modal>
    </DashboardLayout>
  );
};
export default Departments;
